export const typeMap = {
  'HK_STOCK': {
    className: 'blue-bg',
    bgimg: require('@/assets/images/quotes/img_hk.png'),
    fontColor: '#2D60E0'
  },
  'HK_STOCK_INTERNATIONAL': {
    className: 'global-bg',
    bgimg: require('@/assets/images/quotes/global.png'),
    fontColor: '#4fa6e7'
  },
  'US_STOCK': {
    className: 'blue-bg',
    bgimg: require('@/assets/images/quotes/img_us.png'),
    fontColor: '#2D60E0'
  },
  'HK_FUTURES': {
    className: 'blue-bg',
    bgimg: require('@/assets/images/quotes/img_hk.png'),
    fontColor: '#2D60E0'
  },
  'HK_FUTURES_INTERNATIONAL': {
    className: 'global-bg',
    bgimg: require('@/assets/images/quotes/global.png'),
    fontColor: '#4fa6e7'
  },
  'CHICAGO_FUTURES': {
    className: 'globalfutures-bg',
    bgimg: require('@/assets/images/quotes/global.png'),
    fontColor: '#20A3A7'
  },
  'SINGAPORE_FUTURES': {
    className: 'globalfutures-bg',
    bgimg: require('@/assets/images/quotes/global.png'),
    fontColor: '#20A3A7'
  },
  'MIXIN': {
    className: 'mixin-bg',
    bgimg: require('@/assets/images/quotes/mixin.png'),
    fontColor: '#20C189'
  },
  'EDDID_PRO_ADVANCED': {
    className: 'global-bg',
    bgimg: require('@/assets/images/quotes/global.png'),
    fontColor: '#4fa6e7'
  },
  'EDDID_PRO_BASIS': {
    className: 'global-bg',
    bgimg: require('@/assets/images/quotes/global.png'),
    fontColor: '#4fa6e7'
  }
}
